export default __webpack_public_path__ + "static/media/filter-icon.e9378b11.svg";